import React, { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Paper,
  Button,
  Card,
  CardContent,
  CardActionArea,
} from "@material-ui/core";

import noDataImage from "../Images/nodata.webp";

import Loading from "./Loading";

import { withStyles } from "@material-ui/styles";
import styles from "./Styles/BookScreenStyles";

import API from "../Services/API";
import { Call } from "@material-ui/icons";

const ResourceSelection = (props) => {
  let { classes } = props;
  const [noData, setNoData] = useState("");
  const [loading, setLoading] = useState(false);
  const [call, setCall] = useState(false);
  const api = API.create();
  const [providers, setProviders] = useState("");

  const hasAutoSelectedRef = React.useRef(false);
  const prevLocationRef = React.useRef(props.moveToResource.selectedLocation);

  const initialLoad = (insuranceParam) => {
    const insuranceToUse = insuranceParam !== undefined ? insuranceParam : props.moveToResource.insuranceId;
    setLoading(true);
    api.getDoctorsList(
      {
        dbname: props.moveToResource.dbname,
        selectedLocation: props.moveToResource.selectedLocation,
        referralTypes: props.moveToResource.referralTypes,
        insurance: insuranceToUse || ""
      },
      (providerRes) => {
        setLoading(false);
        if (providerRes && providerRes.status === 200) {
          let providerResObj = providerRes.data;
          if (providerResObj && providerResObj.length > 0) {
            setNoData("false");
            setProviders(providerResObj);

            // Verify if the currently selected provider is still in this new list
            if (props.moveToResource.selectedProvider) {
              const providerList = Array.isArray(providerResObj) ? providerResObj : Object.values(providerResObj);
              const stillValid = providerList.some((p) => {
                const docVal = [p.schResourceId, p.schResourceDoctorId].join("@");
                return docVal === props.moveToResource.selectedProvider;
              });
              if (!stillValid) {
                // Doctor doesn't accept the new insurance, clear selection
                resSelected("", "");
                hasAutoSelectedRef.current = false;
              }
            }

            if (!call && props.moveToResource.modes == 1 && props.moveToResource.resourceIds != null && props.moveToResource.resourceIds != -1) {
              setCall(true);
              resSelected(props.moveToResource.resourceIds, props.moveToResource.resourceNames);
            }
          } else {
            setNoData("true");
            setProviders([]);
            if (props.moveToResource.selectedProvider) {
              resSelected("", "");
              hasAutoSelectedRef.current = false;
            }
          }
        } else {
          setNoData("true");
          setProviders([]);
          if (props.moveToResource.selectedProvider) {
            resSelected("", "");
            hasAutoSelectedRef.current = false;
          }
        }
      }
    );
  };

  useEffect(() => {
    if (props.moveToResource.selectedLocation !== prevLocationRef.current) {
      prevLocationRef.current = props.moveToResource.selectedLocation;
      hasAutoSelectedRef.current = false;
    }
  }, [props.moveToResource.selectedLocation]);

  useEffect(() => {
    if (props.moveToResource.selectedLocation) {
      initialLoad(props.moveToResource.insuranceId);
    }
  }, [
    props.moveToResource.selectedLocation,
    props.moveToResource.insuranceId,
    props.moveToResource.referralTypes,
    props.moveToResource.dbname
  ]);

  useEffect(() => {
    // Only auto-select once when targetDoctorId matches, no provider is currently selected,
    // not currently loading new doctors, and the resource panel is expanded/active.
    if (
      !loading &&
      !hasAutoSelectedRef.current &&
      !props.moveToResource.selectedProvider &&
      props.moveToResource.isResourceExpanded &&
      providers &&
      providers.length > 0 &&
      props.moveToResource.targetDoctorId &&
      props.moveToResource.targetDoctorId !== "-1"
    ) {
      const targetDocId = String(props.moveToResource.targetDoctorId).trim();
      const providerList = Array.isArray(providers) ? providers : Object.values(providers);
      const matched = providerList.find(
        (p) =>
          (p.schResourceDoctorId != null && String(p.schResourceDoctorId).trim() === targetDocId) ||
          (p.schResourceId != null && String(p.schResourceId).trim() === targetDocId) ||
          (p.doctorId != null && String(p.doctorId).trim() === targetDocId) ||
          (p.docId != null && String(p.docId).trim() === targetDocId)
      );

      if (matched) {
        hasAutoSelectedRef.current = true;
        const resourceValue = [matched.schResourceId, matched.schResourceDoctorId].join("@");
        const formattedName = matched.schResourceName
          ? matched.schResourceName
            .split(" ")
            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
            .join(" ")
          : "";
        resSelected(resourceValue, formattedName);
      }
    }
  }, [
    loading,
    props.moveToResource.isResourceExpanded,
    providers,
    props.moveToResource.targetDoctorId,
    props.moveToResource.selectedProvider
  ]);

  const resSelected = (resourceValue, resourName) => {
    props.moveToResource.resSelected(
      resourceValue,
      props.moveToResource.dbname,
      resourName
    );
  };

  return (
    <div>
      {loading && (
        <Loading />
      )}
      {!loading && (
        <Grid container spacing={1} elevation={0} >
          {providers.length == 0 && <Typography variant="p" className={classes.noData}>None</Typography>}
          {providers.length > 0 &&
            Object.keys(providers).map((key, index) => {
              const currentDocVal = [providers[key].schResourceId, providers[key].schResourceDoctorId].join("@");
              const isSelectedDoc = props.moveToResource.selectedProvider === currentDocVal;

              return (
                <Grid item key={key} md={3} xs={6} className={classes.itemPanelGrid} justify="space-between">
                  <Card
                    className={classes.itemPanelCard}
                    style={{
                      border: isSelectedDoc ? "2px solid #204a87" : "1px solid #e0e0e0",
                      backgroundColor: isSelectedDoc ? "#eef4fd" : "#ebebeb",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <CardActionArea
                      onClick={resSelected.bind(
                        null,
                        currentDocVal,
                        providers[key].schResourceName
                          .split(" ")
                          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                          .join(" ")
                      )}
                    >
                      <CardContent
                        className={classes.contentHover}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          style={{
                            fontSize: 14,
                            color: isSelectedDoc ? "#204a87" : "#4f4f4f",
                            fontWeight: isSelectedDoc ? 600 : "normal"
                          }}
                        >
                          {providers[key].schResourceName
                            .split(" ")
                            .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                            .join(" ")}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              );
            })}
        </Grid>
      )}
    </div>
  );
};

export default withStyles(styles)(ResourceSelection);
